"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Serializable = void 0;
const ethers_1 = require("ethers");
const utils_1 = require("./utils");
class Serializable {
    toBytesHex() {
        const serializedBytes = this.toBytes();
        return ethers_1.ethers.utils.hexlify(serializedBytes);
    }
    toBytesHexWithout0xPrefix() {
        const serializedBytes = this.toBytes();
        return (0, utils_1.hexlifyWithout0xPrefix)(serializedBytes);
    }
    toJSON() {
        const serializedPlainObj = this.toObj();
        return JSON.stringify(serializedPlainObj);
    }
}
exports.Serializable = Serializable;
//# sourceMappingURL=Serializable.js.map